export class LegacyConversion {
  legacyVersionId: number;
  convertedVersionId: number;
  newSpecification: boolean;
}
